var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPieSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.962 15H17V1.036C17 .472 17.381 0 18 0c7.731 0 14 6.269 14 14 0 .563-.475 1-1.038 1zM11.887 2.324C13.02 2.085 14 3.013 14 4.169V18h13.831c1.157 0 2.082.981 1.844 2.113C28.244 26.905 22.219 32 15 32 6.719 32 0 25.288 0 17 0 9.781 5.096 3.758 11.887 2.324z"
  })));
}
export default SvgChartPieSimple;